<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				ref='table'
				size="mini"
				@row-dblclick='rowClick'
				:height="tableHeight"
				@selection-change="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="50"
					align="center">
				</el-table-column>
				<el-table-column
					prop="imgurl"
					label="商品图片"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<img v-if="scope.row.imgurl === ''" src="~/images/img/no-goods-img.png" style="width: 100px; height:100px">
						<w-image v-else :src="scope.row.imgurl" style="width: 100px;height:100px"></w-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="goodsName"
					label="商品名称"
					align="center"
					min-width="180">
				</el-table-column>
				<template v-for="(item, index) in cols" >
					<el-table-column
						v-if="bigcategoryview === 1 ? item.show : item.show && item.label !== '店铺级小类'"
						:key="`col_${index}`"
						:prop="item.prop"
						:label="item.label"
						:min-width="item.width"
						:align="item.align">
					</el-table-column>
				</template>
				<el-table-column
					prop="saleState"
					label="可售状态"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					v-if="auditStateShow !== 0"
					prop="auditState"
					label="审核状态"
					align="center"
					min-width="100">
					<template slot-scope="scope">
						<p v-if="scope.row.auditState === '驳回'" style="color:#f6191e">驳回</p>
						<p v-else-if="scope.row.auditState === '通过'" style="color:#118f29">通过</p>
						<p v-else-if="scope.row.auditState === '待审核'" style="color:#9518b4">待审核</p>
						<p v-else>{{scope.row.auditState}}</p>
					</template>
				</el-table-column>
				<el-table-column
					prop="unitFlag"
					label="计量单位"
					align="center"
					min-width="90">
					<template slot-scope="scope">
						<span v-if="scope.row.unitFlag === 1">有</span>
						<span v-else>无</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="hiddenFlag"
					label="私密状态"
					align="center"
					min-width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.hiddenFlag === 0">公开</span>
						<span v-else>私密</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" align="center" v-if="deleteAuthority || viewAuthority">
					<template slot-scope="scope">
						<el-button type='text' size="mini" icon="el-icon-delete" @click="delGoods(scope.row)" v-if="deleteAuthority">删除</el-button>
						<el-button type='text' size="mini" icon="el-icon-search" @click="getDetail(scope.row)" v-if="viewAuthority">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
import { cols } from '@/js/business/goodsManagementCols/mainTableCols'
export default {
	name: 'mainTable',
	props: {
		deleteAuthority: Boolean,
		viewAuthority: Boolean,
		totalCount: Number,
		tableData: Array,
		auditStateShow: Number
	},
	data () {
		return {
			tableHeight: '100%',
			cols: cols,
			pagination: {
				page: 1,
				size: 20
			},
			bigcategoryview: 0
		}
	},
	created () {
		let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
		if (goodsInfoStr) {
			this.pagination.size = JSON.parse(goodsInfoStr).size
			this.pagination.page = JSON.parse(goodsInfoStr).page
		}
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
		})
	},
	watch: {
		tableData: {
			handler (value) {
				let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
				if (goodsInfoStr) {
					let scrollTopValue = JSON.parse(goodsInfoStr).scrollTopValue
					let tableContainer = document.querySelector('.el-table__body-wrapper')
					this.$nextTick(() => {
						tableContainer.scrollTop = scrollTopValue
						this.$refs.table.doLayout()
					})
				}
			},
			immediate: false
		}
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		initPage () {
			this.pagination.page = 1
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.id
			})
			this.$emit('delIds', ids)
		},
		handleSizeChange (value) {
			let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
			if (goodsInfoStr) {
				let goodsInfo = JSON.parse(goodsInfoStr)
				goodsInfo.size = value
				window.sessionStorage.setItem('goodsInfo', JSON.stringify(goodsInfo))
			}
			this.$emit('sizeChange', value)
			this.pagination.size = value
		},
		handlePageChange (value) {
			let goodsInfoStr = window.sessionStorage.getItem('goodsInfo')
			if (goodsInfoStr) {
				let goodsInfo = JSON.parse(goodsInfoStr)
				goodsInfo.scrollTopValue = 0
				goodsInfo.page = value
				window.sessionStorage.setItem('goodsInfo', JSON.stringify(goodsInfo))
			}
			this.$emit('pageChange', value)
			this.pagination.page = value
		},
		getDetail (data) {
			let tableContainer = document.querySelector('.el-table__body-wrapper')
			let scrollTopValue = tableContainer.scrollTop
			window.sessionStorage.setItem('goodsid', data.id)
			window.sessionStorage.setItem('goodName', data.goodsName)
			window.sessionStorage.setItem('goodHiddenFlag', data.hiddenFlag)
			window.sessionStorage.setItem('goodsAdd', false)
			let tableData = {
				scrollTopValue: scrollTopValue,
				size: this.pagination.size,
				page: this.pagination.page
			}
			this.$emit('saveSearch', tableData)
		},
		delGoods (data) {
			this.$confirm('是否删除商品？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					ids: data.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/delGoods`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('delSuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		}
	}
}
</script>

<style lang="stylus" scoped>
.grid-content {
	/deep/.el-table__body-wrapper {
	height: calc(100% - 44px) !important;
	}
}
.main-table {
	display flex
	flex: 1
	flex-direction: column
	height: 100%
	min-height: 0
	.main-table-box {
		flex: 1;
		padding-bottom 10px;
		overflow-y: auto;
	}
}
</style>
